import classNames from "classnames";
import React, { memo } from "react";
import { useApp } from "../../../App";
import { CustomAsset } from "../../../hooks/useCards";
import { StakedAssetModel } from "../../../stores/StakedAssetModel";
import AssetViewStaked from "../AssetViewStaked";
import AssetViewUnstaked from "../AssetViewUnstaked";
import { NoCardsView } from "../NoCardsView";
import Styles from "./AssetListView.module.scss";
import { AssetExaminerMode } from "./index";

type PropsType = {
	assets: CustomAsset[]
	mode: AssetExaminerMode
}

export const AssetListView = ({assets, mode}: PropsType) => {
	const app = useApp();
	const isOnlyStaked = mode === "ONLY_STAKED";
	const result = assets.map((item: CustomAsset) => {
		if (item instanceof StakedAssetModel) {
			return <AssetViewStaked mode={mode} asset={item} key={item.assetId}/>;
		}
		return mode === "ALL" ? <AssetViewUnstaked asset={item} key={`unstaked-${item.assetId}`}/> : null;
	});

	if (!result.length) {
		return <NoCardsView/>;
	}

	if (!app.store.activeCard && isOnlyStaked) {
		app.store.setActiveCard(assets[0] as StakedAssetModel);
	}

	return (
		<div className={classNames(
			Styles.stylePageViewsContainer,
			{[Styles.styleHomePageViewsContainer]: isOnlyStaked},
		)}>
			{result}
		</div>
	);
};
